import React from 'react';

const Badge = ({ 
  children, 
  className = '', 
  variant = 'red',
  size = 'sm',
  ...props 
}) => {
  const variants = {
    red: 'bg-v3-red-primary text-white',
    purple: 'bg-v3-purple-primary text-white',
    green: 'bg-v3-green-primary text-white',
    gray: 'bg-v3-black-secondary text-white'
  };

  const sizes = {
    xs: 'w-4 h-4',
    sm: 'w-6 h-6',
    md: 'w-6 h-6',
    lg: 'w-8 h-8'
  };

  return (
    <span
      className={`
        flex
        items-center
        justify-center
        rounded-full
        text-white
        text-center
        font-bolder
        font-inter-variable
        text-xs
        leading-5
        ${variants[variant] || variants.red}
        ${sizes[size] || sizes.sm}
        ${className}
      `}
      {...props}
    >
      {children}
    </span>
  );
};

export default Badge;
